import { connect } from 'react-redux';
import { selectors } from '@amplement/backend-connector';

import Component from './index';

const mapStateToProps = (state, ownProps) =>
    selectors.voiceMails.getVoiceMailByIdSelector(state, ownProps._voiceMail);

export default connect(mapStateToProps, null)(Component);
